/**
 * デバイス名 上限文字数
 */
export const DEVICE_NAME_MAX_LENGTH = 25

/**
 * 備考 上限文字数
 */
export const REMARKS_MAX_LENGTH = 50
